import moment from 'moment';
import { defaultGovernmentCharges } from 'scenes/common/flows/coverOptions/defaults';

import {
  AustralianState,
  BuildingLevel,
  BuildingType,
  CoverType,
  PolicyIssued,
  SumInsuredType,
  YesNoAnswer,
} from 'scenes/common/types';
import {
  HomeQuoteData,
  InsuranceOption,
  KickOutChoice,
  PropertyPurposeType,
} from 'scenes/home/types';

export const defaultHomeQuoteDetails: HomeQuoteData = {
  coverType: CoverType.Unspecified,
  prefilledCampaignId: '',
  prefilledPromoCode: '',
  colesCampaignCode: '',
  policyStartDate: moment().format('YYYY-MM-DD'),
  riskAddress: {
    address: '',
    addressLine1: '',
    addressLine2: '',
    gnaf: '',
    houseNo: '',
    latitude: 0,
    longitude: 0,
    lotNo: '',
    postcode: '',
    state: AustralianState.ACT,
    streetName: '',
    streetPrefix: '',
    streetSuffix: '',
    suburb: '',
    unitNo: '',
  },
  ownedProperty: YesNoAnswer.Unspecified,
  propertyUsedForBusiness: YesNoAnswer.Unspecified,
  propertyBusinessType: '',
  purposeOfProperty: PropertyPurposeType.Unspecified,
  kickOutChoice: KickOutChoice.Unspecified,
  policyIssued: PolicyIssued.Unspecified,
  policyHolderDateOfBirth: '',
  businessOwnerDateOfBirth: '',
  recentInsurer: '',
  yearsInsured: -1,
  claimsMade: -1,
  brokenInClaims: YesNoAnswer.Unspecified,
  additionalSecurityInstalled: YesNoAnswer.Unspecified,
  buildingType: BuildingType.Unspecified,
  freestandingMetreGap: YesNoAnswer.Unspecified,
  freestandingStorey: YesNoAnswer.Unspecified,
  terraceStorey: YesNoAnswer.Unspecified,
  terraceStrata: YesNoAnswer.Unspecified,
  townhouseStorey: YesNoAnswer.Unspecified,
  townhouseStrata: YesNoAnswer.Unspecified,
  unitStorey: YesNoAnswer.Unspecified,
  unitLevel: BuildingLevel.Unspecified,
  unitStrata: YesNoAnswer.Unspecified,
  numberOfBedrooms: -1,
  propertyBuiltYear: '',
  certificateOfOccupancy: YesNoAnswer.Unspecified,
  roofMaterial: '',
  wallMaterial: '',
  securityFeatures: [],
  agreedSumInsuredRange: {
    lowerLimit: '',
    upperLimit: '',
  },
  estimatedSumInsured: '',
  sumInsuredType: SumInsuredType.Unspecified,
  agreedBuildingSumInsured: '',
  contentsSumInsured: '',

  hasFlybuys: YesNoAnswer.Unspecified,
  flybuysNumber: '',
  promoCode: '',
};

export const defaultInsurancePremium: InsuranceOption = {
  coverType: CoverType.Unspecified,
  premium: {
    price: '',
    firstInstalment: '',
    monthlyInstalment: '',
    annualPrice: '',
    yearlyGovernmentCharges: defaultGovernmentCharges,
    monthlyGovernmentCharges: defaultGovernmentCharges,
  },
};
